import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

export default function TypesCoffee() {
    return (
        <section className="py-5">
            <Container>
                <h2 className="fs-3 mb-5 fw-bold make-serif text-center secondary-text"><span className="fw-light make-serif">Types of </span>Coffee Beans</h2>
                <Row className="g-4">
                    <Col sm={12} md={5} className="offset-lg-1">
                        <div className="intro-box mb-4">
                            <div className="intro-box-img">
                                <img src="/coffee-beans.png" alt="Arabia Coffee" />
                            </div>
                            <div className="intro-box-content ms-3">
                                <h6 className="fs-5 fw-medium">Coffea arabica</h6>
                                <p className="small-text-01">Arabica beans are by far the most popular type of coffee beans, making up about 60% of the world's coffee.</p>
                            </div>
                        </div>
                        <div className="intro-box mb-4">
                            <div className="intro-box-img">
                                <img src="/coffee-beans.png" alt="Robusta Coffee" />
                            </div>
                            <div className="intro-box-content ms-3">
                                <h6 className="fs-5 fw-medium">Coffea robusta</h6>
                                <p className="small-text-01">Robusta beans are larger and more rounded than the other bean varieties. </p>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={5} >
                        <div className="intro-box mb-4">
                            <div className="intro-box-img">
                                <img src="/coffee-beans.png" alt="Liberica Coffee" />
                            </div>
                            <div className="intro-box-content ms-3">
                                <h6 className="fs-5 fw-medium">Coffea liberica</h6>
                                <p className="small-text-01">This hardy species is frequently mixed with other varieties to add body and complexity.</p>
                            </div>
                        </div>
                        <div className="intro-box">
                            <div className="intro-box-img">
                                <img src="/coffee-beans.png" alt="Excelsa Coffee" />
                            </div>
                            <div className="intro-box-content ms-3">
                                <h6 className="fs-5 fw-medium">Coffee excelsa</h6>
                                <p className="small-text-01">Excelsa beans grow almost entirely in Southeast Asia, and they're shaped lie Liberica beans.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
